"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable:no-console */

var FallbackLog =
/*#__PURE__*/
function () {
  function FallbackLog() {
    _classCallCheck(this, FallbackLog);
  }

  _createClass(FallbackLog, null, [{
    key: "log",
    value: function log(msg) {
      console.error("UniverseLog.FallbackLog: ".concat(msg));
    }
  }]);

  return FallbackLog;
}();

exports.FallbackLog = FallbackLog;